import PropTypes from "prop-types";
import { Rnd } from "react-rnd";
import { Box } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateElement } from "../../../store/formSlice";

const LogoComponent = ({
  elementId,
  base64Src,
  alt,
  width,
  border,
  height,
  marginLeft = '',
  marginTop = '',
  onResizeLogo,
}) => {
  //const dispatch = useDispatch();
  // const handleDragStop = (e, data) => {
  //   console.log(data, 'data');
  //   const updatedElementDrag = {
  //     id: elementId,
  //     element: {b
  //       elementId: elementId,
  //       x: data.x,
  //       y: data.y,
  //     },
  //   };
  //   console.log(updatedElementDrag, 'updatedElementDrag');
  //   dispatch(updateElement(updatedElementDrag));
  // };
  const handleResizeStop = (e, direction, ref, delta, position) => {
    // const updatedElementResize = {
    //   id: elementId,
    //   element: {
    //     elementId: elementId,
    //     width: ref.style.width,
    //     height: ref.style.height,
    //     x: position.x,
    //     y: position.y,
    //   },
    // };
    const updatedHeight = ref.style.height;
    const updatedWidth = ref.style.width;
    const updatedX = position.x;
    const updatedY = position.y;
    onResizeLogo(updatedHeight, updatedWidth, updatedX, updatedY);
  };
  return (
    <Box
      sx={{
        position: "absolute",
        zIndex: 10,
      }}
    >
      <Rnd
        //disableDragging={true}
        default={{
          x: 7,
          y: 0,
          width: "100px",
          height: "80px",
        }}
        enableResizing={{
          top: true,
          right: true,
          bottom: true,
          left: true,
          topRight: true,
          bottomRight: true,
          bottomLeft: true,
          topLeft: true,
        }}
        size={{ width: width || "200px", height: height || "150px" }}
        position={{ x: marginLeft ?? '0', y: marginTop ?? '0' }}
        //onDragStop={handleDragStop}
        onResizeStop={handleResizeStop}
      >
        <Box
          justifyContent="center"
          component="img"
          src={`data:image/png;base64,${base64Src}`}
          alt={alt}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            border: border ? "1px solid #D3D3D3" : "none",
            margin: "0 auto",
            display: "block",
            position: "relative",
            "@media (max-width: 600px)": {
              width: "80%",
              height: "auto",
            },
            "@media (min-width: 601px) and (max-width: 1024px)": {
              width: "60%",
              height: "auto",
            },
          }}
        />
      </Rnd>
    </Box>
  );
};

LogoComponent.propTypes = {
  base64Src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  marginLeft: PropTypes.string,
  marginTop: PropTypes.string,
};

export default LogoComponent;
